import { gql, TypedDocumentNode } from "@apollo/client";

import {
  Blueprint,
  BlueprintVersionedGroup,
  BlueprintVersionedGroupBlueprintVersionArgs,
  BlueprintVersionedGroupSearchBlueprintVersionsArgs,
  BlueprintVersionedGroupSearchBlueprintVersionsSuggestionsArgs,
  MutationBlueprintVersionCreateArgs,
  MutationBlueprintVersionDeleteArgs,
  MutationBlueprintVersionUpdateArgs,
} from "types/generated";

type SearchBlueprintVersionedGroupsData = {
  blueprintVersionedGroup: BlueprintVersionedGroup;
};

export const SEARCH_TEMPLATE_VERSIONS: TypedDocumentNode<
  SearchBlueprintVersionedGroupsData,
  BlueprintVersionedGroupBlueprintVersionArgs & BlueprintVersionedGroupSearchBlueprintVersionsArgs
> = gql`
  query SearchTemplateVersions($id: ID!, $input: SearchInput!) {
    blueprintVersionedGroup(id: $id) {
      id
      searchBlueprintVersions(input: $input) {
        edges {
          cursor
          node {
            id
            description
            instructions
            name
            state
            space {
              id
              name
              accessLevel
            }
            ulid
            updatedAt
            version
            deploymentsCount
          }
        }
        pageInfo {
          hasPreviousPage
          hasNextPage
          startCursor
          endCursor
        }
      }
    }
  }
`;

type SearchTemplateVersionsSuggestionsData = {
  blueprintVersionedGroup: BlueprintVersionedGroup;
};

export const SEARCH_TEMPLATE_VERSIONS_SUGGESTIONS: TypedDocumentNode<
  SearchTemplateVersionsSuggestionsData,
  BlueprintVersionedGroupBlueprintVersionArgs &
    BlueprintVersionedGroupSearchBlueprintVersionsSuggestionsArgs
> = gql`
  query SearchTemplateVersionsSuggestions($id: ID!, $input: SearchSuggestionsInput!) {
    blueprintVersionedGroup(id: $id) {
      id
      searchBlueprintVersionsSuggestions(input: $input) {
        filteredCount
        fields {
          name
          orderable
          filterable
          type
          possibleValuesBoolean {
            values
            counts
          }
          possibleValuesEnum {
            values
            counts
          }
          possibleValuesString {
            values
            counts
          }
          possibleValuesHierarchy {
            values {
              id
              parentId
              displayValue
            }
            counts
          }
        }
      }
    }
  }
`;

type DeleteBlueprintVersionData = {
  blueprintVersionDelete: Pick<Blueprint, "id" | "name" | "version">;
};

export const DELETE_VERSION: TypedDocumentNode<
  DeleteBlueprintVersionData,
  MutationBlueprintVersionDeleteArgs
> = gql`
  mutation BlueprintVersionDeploymentDelete($id: ID!) {
    blueprintVersionDelete(id: $id) {
      id
      name
      version
    }
  }
`;

type CreateVersionData = {
  blueprintVersionCreate: Pick<Blueprint, "id" | "name" | "version">;
};

export const CREATE_VERSION: TypedDocumentNode<
  CreateVersionData,
  MutationBlueprintVersionCreateArgs
> = gql`
  mutation BlueprintVersionCreate($input: BlueprintVersionCreateInput!) {
    blueprintVersionCreate(input: $input) {
      id
      name
      version
    }
  }
`;

type UpdateVersionData = {
  blueprintVersionUpdate: Pick<Blueprint, "id" | "name" | "version">;
};

export const UPDATE_VERSION: TypedDocumentNode<
  UpdateVersionData,
  MutationBlueprintVersionUpdateArgs
> = gql`
  mutation UpdateVersion($id: ID!, $input: BlueprintVersionUpdateInput!) {
    blueprintVersionUpdate(id: $id, input: $input) {
      id
      name
      version
    }
  }
`;
